import { useEffect } from 'react';

/**
 * Плашка «сделано · Отменить» внизу экрана (3.1.12).
 *
 * Для действий, после которых задача уходит с экрана: переносу свайпом
 * паузы на месте, как у галочки (3.1.8), не дать — переносят пачкой, и
 * висящие строки сдвигались бы под пальцем, следующий свайп приходился бы не
 * на ту задачу. Строка уходит сразу, а отменить можно здесь. Плашка одна:
 * новый перенос заменяет её, отменяется последний.
 */

export interface UndoNotice {
  /** Новый номер — новая плашка: таймер начинается заново. */
  id: number;
  text: string;
  undo: () => void;
}

/** Сколько плашка на экране. */
const UNDO_MS = 5000;

export function UndoBar({
  notice,
  onClose,
}: {
  notice: UndoNotice | undefined;
  onClose: () => void;
}): React.ReactElement | null {
  useEffect(() => {
    if (notice === undefined) return undefined;
    const timer = setTimeout(onClose, UNDO_MS);
    return () => clearTimeout(timer);
  }, [notice, onClose]);

  if (notice === undefined) return null;

  // `key` по номеру: новый перенос — новая плашка, и полоса времени
  // начинается заново, а не продолжает чужую.
  return (
    <div key={notice.id} className="undo" role="status">
      <span className="undo__text">{notice.text}</span>
      <button
        type="button"
        className="undo__button"
        onClick={() => {
          notice.undo();
          onClose();
        }}
      >
        Отменить
      </button>
      {/*
        Полоса времени — как у закрытия задачи (3.1.8): дошла до края — плашка
        ушла. Без неё плашка выглядела постоянной, а отмена — доступной всегда
        (замечание владельца 2026-10-18). Длительность — из той же константы,
        что и таймер: две цифры в разных местах разъехались бы.
      */}
      <span
        className="undo__timer"
        aria-hidden="true"
        style={{ animationDuration: `${String(UNDO_MS)}ms` }}
      />
    </div>
  );
}
